(function (Drupal, $) {
  Drupal.behaviors.authStatus = {
    attach: function attach() {
      const data = localStorage.getItem('reduxStore');

      if (data && data.length) {
        const json = Flatted.parse(data);
        const appState = json.appState;
        if (appState.authentication && appState.authentication.firstname.length) {
          $('.sign-in .sign-in-link').text(Drupal.t('Hi @username', { '@username': appState.authentication.firstname}));
          $('.layout__region--mobile-header .authorized-menu').css('display','flex');
          $('.layout__region--mobile-header .log-out').css('display','flex');
          $('.layout__region--mobile-header .sign-up').hide();
          $('.layout__region--mobile-header .log-in').hide();
          $('.sign-in a').attr('href', '/account/settings');
        }
      }
    }
  };
})(Drupal, jQuery, drupalSettings);
